import React from "react";
import { connect } from "react-redux";
import { setAlert } from "../../action/alert";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import { Box } from "@mui/material";
import AppTabs from "../Common/Tabs/AppTabs";
import CreateQRCode from "./createQRCode";
import FetchQRCode from "./fetchQRCode";
import QRCodeFilter from "./qrCodeCountFilter";

const QR_TABS = [
    { label: "Create and Print QR Code" },
    { label: "Fetch and Print QR Code" },
    { label: "QR Code Count" }
];

const QRCode = ({
    wrapperClass,
    allowedDeviceCategories,
    allowedCompanyBrand,
    setAlert
}) => {
    const [activeTab, setActiveTab] = React.useState(0)

    return (
        <ResponsiveContentWrapper className={wrapperClass || ""}>
            <Box className="qr-code-config" sx={{ width: "100%", minWidth: 0, maxWidth: "100%", overflow: "hidden" }}>
                <AppTabs
                    value={activeTab}
                    onChange={(e, newValue) => setActiveTab(newValue)}
                    tabs={QR_TABS}
                    variant="scrollable"
                    scrollButtons="auto"
                    tabMinWidth="auto"
                    appearance="neutral"
                />
                <Box sx={{ mt: 2, width: "100%", minWidth: 0, maxWidth: "100%" }}>
                {activeTab === 0 && (
                    <CreateQRCode
                        allowedDeviceCategories={allowedDeviceCategories}
                        allowedCompanyBrand={allowedCompanyBrand}
                        setAlert={setAlert}
                    />
                )}
                {activeTab === 1 && (
                    <FetchQRCode
                        allowedDeviceCategories={allowedDeviceCategories}
                        allowedCompanyBrand={allowedCompanyBrand}
                        setAlert={setAlert}
                    />
                )}
                {activeTab === 2 && (
                    <QRCodeFilter
                        setAlert={setAlert}
                    />
                )}
                </Box>
            </Box>
        </ResponsiveContentWrapper>
    );
}

const mapStateToProps = (state) => ({
    allowedDeviceCategories: state.auth.allowedDeviceCategories,
    allowedCompanyBrand: state.auth.allowCompanyBrand,
});

const mapDispatchToProps = (dispatch) => ({
    setAlert: (message, status) => dispatch(setAlert(message, status))
});

export default connect(mapStateToProps, mapDispatchToProps)(QRCode);